/**
 * Единый словарь категорий подрядчиков (Блок 8 каталог + Блок 9 заявка + контракт
 * cooperation). Значения verbatim — P-001 (без нормализации: «ё», запятые, « / », скобки).
 * ADR-0098. Перенесено как есть из `apps/web/src/features/partners/categories.ts`.
 */

export const PARTNER_CATEGORIES = [
  'Распил, закатка, присадка',
  'Фасады плёнка',
  'Фасады краска',
  'Фасады шпон',
  'МДФ фрезеровка (черновые фасады)',
  'Каменщики',
  'Зеркала / стёкла / витрины',
  'Мягкая мебель',
  'Подсветка',
  'Газели',
  'Грузчики',
] as const;
export type PartnerCategory = (typeof PARTNER_CATEGORIES)[number];

export const RASPIL_CATEGORY = 'Распил, закатка, присадка';

export const RASPIL_SUBCATEGORIES = ['Пильный центр', 'ЧПУ', 'Присадка ЧПУ'] as const;
export type RaspilSubcategory = (typeof RASPIL_SUBCATEGORIES)[number];
